<div class="container-1" *ngIf="!isFormSubmitted">
  <mat-card>
    <h1 *ngIf="invalidForm">Please fill data in all the mandatory fields.</h1>
    <mat-stepper orientation="vertical" #stepper>
      <mat-step [stepControl]="personalInfo">
        <form [formGroup]="personalInfo">
          <ng-template matStepLabel>Personal Details</ng-template>
          <mat-form-field appearance="outline">
            <mat-label>First Name</mat-label>
            <input matInput type="name" formControlName="firstName" />
            <!-- <mat-error *ngIf="studentForm.controls['firstName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Last Name</mat-label>
            <input matInput type="name" formControlName="lastName" />
            <!-- <mat-error *ngIf="studentForm.controls['lastName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Email Id</mat-label>
            <input
              matInput
              type="email"
              placeholder="xyz@gmail.com"
              formControlName="email"
            />
            <!-- <mat-error *ngIf="studentForm.controls['email'].invalid">{{getErrorMessage()}}</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Age</mat-label>
            <input matInput type="number" formControlName="age" />
            <!-- <mat-error *ngIf="studentForm.controls['lastName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Country</mat-label>
            <input matInput type="text" formControlName="country" />
            <!-- <mat-error *ngIf="studentForm.controls['address'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>City</mat-label>
            <input matInput type="text" formControlName="city" />
            <!-- <mat-error *ngIf="studentForm.controls['city'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Mobile Number</mat-label>
            <input
              matInput
              type="number"
              placeholder="enter number with country code"
              formControlName="phoneNumber"
            />
            <!-- <span matTextPrefix><span class="fi fi-in"></span>&nbsp;+91&nbsp;</span> -->
            <!-- <mat-error *ngIf="studentForm.controls['phoneNumber'].invalid && !invalidNum">You must enter a value</mat-error>
                <mat-error *ngIf="studentForm.controls['phoneNumber'].invalid && invalidNum">Please enter a valid number</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Marital Status</mat-label>
            <select matNativeControl required formControlName="maritalStatus">
              <option *ngFor="let m of marital" [value]="m">{{ m }}</option>
            </select>
            <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Occupation</mat-label>
            <input matInput type="text" formControlName="occupation" />
            <!-- <mat-error *ngIf="studentForm.controls['city'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <div class="gender">
            <mat-label>Gender</mat-label>
            <mat-radio-group
              aria-labelledby="Select an option"
              formControlName="gender"
            >
              <mat-radio-button value="Male">Male</mat-radio-button>
              <mat-radio-button value="Female">Female</mat-radio-button>
              <mat-radio-button value="Rather Not Say"
                >Rather Not Say</mat-radio-button
              >
            </mat-radio-group>
          </div>
        </form>
        <div class="btn-row">
          <button
            mat-raised-button
            class="secondary-btn"
            (click)="saveForm('personalInfo')"
          >
            Save for later <img [src]="saveIcon" />
          </button>
          <button mat-raised-button class="primary-btn" matStepperNext>
            Next <img [src]="nextIcon" />
          </button>
        </div>
      </mat-step>
      <mat-step [stepControl]="bodyMeasure">
        <form [formGroup]="bodyMeasure" class="body-measure">
          <ng-template matStepLabel>Body Measurements</ng-template>
          <mat-form-field appearance="outline">
            <mat-label>Height (In Feet)</mat-label>
            <input matInput type="number" formControlName="height" />
            <!-- <mat-error *ngIf="studentForm.controls['firstName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Weight (In KG)</mat-label>
            <input matInput type="number" formControlName="weight" />
            <!-- <mat-error *ngIf="studentForm.controls['lastName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Bust (In Inches)</mat-label>
            <input matInput type="number" formControlName="bust" />
            <!-- <mat-error *ngIf="studentForm.controls['email'].invalid">{{getErrorMessage()}}</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Waist (In Inches)</mat-label>
            <input matInput type="number" formControlName="waist" />
            <!-- <mat-error *ngIf="studentForm.controls['lastName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Hips (In Inches)</mat-label>
            <input matInput type="number" formControlName="hips" />
            <!-- <mat-error *ngIf="studentForm.controls['address'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>BMI</mat-label>
            <input matInput type="number" formControlName="bmi" />
            <!-- <mat-error *ngIf="studentForm.controls['address'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
        </form>
        <div class="btn-row">
          <button mat-raised-button class="basic-btn" matStepperPrevious>
            <img [src]="backIcon" /> Back
          </button>
          <button
            mat-raised-button
            class="secondary-btn"
            (click)="saveForm('bodyMeasure')"
          >
            Save for later <img [src]="saveIcon" />
          </button>
          <button mat-raised-button class="primary-btn" matStepperNext>
            Next <img [src]="nextIcon" />
          </button>
        </div>
      </mat-step>
      <mat-step [stepControl]="healthIssues">
        <form [formGroup]="healthIssues" class="health-issue">
          <ng-template matStepLabel>Mention Your Health Issues</ng-template>
          <mat-form-field appearance="outline">
            <mat-label>Daily Activity</mat-label>
            <mat-select required formControlName="dailyActivity">
              <mat-option *ngFor="let m of dailyActivity" [value]="m">{{
                m
              }}</mat-option>
              <mat-divider></mat-divider>
            </mat-select>
            <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Medical Condition? Please select if any.</mat-label>
            <mat-select required formControlName="medicalCondition" multiple>
              <mat-option *ngFor="let m of medicalCondition" [value]="m">{{
                m
              }}</mat-option>
              <mat-divider></mat-divider>
            </mat-select>
            <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Medical History? Please mention if any.</mat-label>
            <textarea
              matInput
              placeholder="enter medical history..."
              formControlName="medicalHistory"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5"
            ></textarea>
            <mat-hint>Ex: Surgery, Accident, Major Illness etc</mat-hint>
            <!-- <mat-error *ngIf="studentForm.controls['email'].invalid">{{getErrorMessage()}}</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Medications? Please mention if any.</mat-label>
            <textarea
              matInput
              placeholder="enter medications..."
              formControlName="aboutMedication"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5"
            ></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Your Eating & Drinking Habits</mat-label>
            <mat-select
              panelClass="panel-style"
              required
              formControlName="dietHabits"
              multiple
            >
              <mat-option *ngFor="let m of dietHabits" [value]="m">{{
                m
              }}</mat-option>
            </mat-select>
            <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="dietHabitsOther">
            <mat-label>Other Habits</mat-label>
            <input
              matInput
              type="number"
              placeholder="enter other habits..."
              formControlName="dietHabitsOther"
            />
            <!-- <mat-error *ngIf="studentForm.controls['address'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Meals Your Prefer</mat-label>
            <mat-select required formControlName="mealPrefer" multiple>
              <mat-option *ngFor="let m of mealPrefer" [value]="m">{{
                m
              }}</mat-option>
            </mat-select>
            <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="mealOther">
            <mat-label>Other Meals</mat-label>
            <input
              matInput
              type="text"
              placeholder="enter other meals..."
              formControlName="mealOther"
            />
            <!-- <mat-error *ngIf="studentForm.controls['address'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Cuisines Your Prefer</mat-label>
            <mat-select required formControlName="cuisinesPrefer" multiple>
              <mat-option *ngFor="let m of cuisinesPrefer" [value]="m">{{
                m
              }}</mat-option>
            </mat-select>
            <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="cuisinesOther">
            <mat-label>Other Cuisines</mat-label>
            <input
              matInput
              type="text"
              placeholder="enter other cuisines..."
              formControlName="cuisinesOther"
            />
            <!-- <mat-error *ngIf="studentForm.controls['address'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Allergy? Please mention if any.</mat-label>
            <textarea
              matInput
              placeholder="enter about allergies..."
              formControlName="foodAllergy"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5"
            ></textarea>
          </mat-form-field>
          <!-- <div class="upload">
            <mat-label>Upload Your Reports</mat-label>
            <app-file-upload [filePath]="filePath"></app-file-upload>
          </div> -->
        </form>
        <div class="btn-row">
          <button mat-raised-button class="basic-btn" matStepperPrevious>
            <img [src]="backIcon" /> Back
          </button>
          <button
            mat-raised-button
            class="secondary-btn"
            (click)="saveForm('healthIssues')"
          >
            Save for later <img [src]="saveIcon" />
          </button>
          <button mat-raised-button class="primary-btn" matStepperNext>
            Next <img [src]="nextIcon" />
          </button>
        </div>
      </mat-step>
      <mat-step [stepControl]="dailyRoutine">
        <form [formGroup]="dailyRoutine" class="daily-routine">
          <ng-template matStepLabel>Daily Routine</ng-template>
          <div class="time-picker">
            <app-time-picker
              [label]="'Your Wake Up Time:'"
              (time)="selectTime($event, 'wakeupTime')"
              [selectedTime]="dailyRoutine.get('wakeupTime')?.value"
            ></app-time-picker>
          </div>
          <div class="time-picker">
            <app-time-picker
              [label]="'Work Start Time'"
              (time)="selectTime($event, 'startWorkTime')"
              [selectedTime]="dailyRoutine.get('startWorkTime')?.value"
            ></app-time-picker>
          </div>
          <div class="time-picker">
            <app-time-picker
              [label]="'Work End Time:'"
              (time)="selectTime($event, 'endWorkTime')"
              [selectedTime]="dailyRoutine.get('endWorkTime')?.value"
            ></app-time-picker>
          </div>
          <mat-form-field appearance="outline">
            <mat-label>Hours of Sleep?</mat-label>
            <input matInput type="number" formControlName="sleepHours" />
            <!-- <mat-error *ngIf="studentForm.controls['firstName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label
              >What you usually eat in breakfast? Please mention.</mat-label
            >
            <input matInput type="text" formControlName="breakfast" />
            <!-- <mat-error *ngIf="studentForm.controls['firstName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <div class="time-picker">
            <app-time-picker
              [label]="'Mention your breakfast time:'"
              (time)="selectTime($event, 'breakfastTime')"
              [selectedTime]="dailyRoutine.get('breakfastTime')?.value"
            ></app-time-picker>
          </div>
          <mat-form-field appearance="outline">
            <mat-label
              >What you usually eat in lunch? Please mention.</mat-label
            >
            <input matInput type="text" formControlName="lunch" />
            <!-- <mat-error *ngIf="studentForm.controls['firstName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <div class="time-picker">
            <app-time-picker
              [label]="'Mention your lunch time:'"
              (time)="selectTime($event, 'lunchTime')"
              [selectedTime]="dailyRoutine.get('lunchTime')?.value"
            ></app-time-picker>
          </div>
          <mat-form-field appearance="outline">
            <mat-label
              >What you usually eat in dinner? Please mention.</mat-label
            >
            <input matInput type="text" formControlName="dinner" />
            <!-- <mat-error *ngIf="studentForm.controls['firstName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <div class="time-picker">
            <app-time-picker
              [label]="'Mention your dinner time:'"
              (time)="selectTime($event, 'dinnerTime')"
              [selectedTime]="dailyRoutine.get('dinnerTime')?.value"
            ></app-time-picker>
          </div>
          <mat-form-field appearance="outline">
            <mat-label
              >What you usually eat in mid meal snacks? Please mention, if
              any.</mat-label
            >
            <input matInput type="text" formControlName="midMealSnacks" />
            <!-- <mat-error *ngIf="studentForm.controls['firstName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <div class="time-picker">
            <app-time-picker
              [label]="'Mention your mid meal snacks time:'"
              (time)="selectTime($event, 'midMealSnacksTime')"
              [selectedTime]="dailyRoutine.get('midMealSnacksTime')?.value"
            ></app-time-picker>
          </div>

          <mat-form-field appearance="outline">
            <mat-label>Workout Routine? Please select, if any.</mat-label>
            <mat-select required formControlName="workoutRoutine" multiple>
              <mat-option *ngFor="let m of workoutRoutine" [value]="m">{{
                m
              }}</mat-option>
            </mat-select>
            <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label
              >Any Specific Diet You Follow? Please select, if any.</mat-label
            >
            <mat-select required formControlName="otherDiet" multiple>
              <mat-option *ngFor="let m of otherDiet" [value]="m">{{
                m
              }}</mat-option>
            </mat-select>
            <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label
              >If you are a house wife, please mention how you spend your
              day.</mat-label
            >
            <textarea
              matInput
              formControlName="housewifeRoutine"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5"
            ></textarea>
            <!-- <input matInput type="text" formControlName="dinner"> -->
            <!-- <mat-error *ngIf="studentForm.controls['firstName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label
              >How you usually spend your weekends? Please mention.</mat-label
            >
            <textarea
              matInput
              formControlName="weekends"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5"
            ></textarea>
            <!-- <input matInput type="text" formControlName="dinner"> -->
            <!-- <mat-error *ngIf="studentForm.controls['firstName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 95%">
            <mat-label
              >Anything else you like to mention about your daily
              routine?</mat-label
            >
            <textarea
              matInput
              formControlName="anything"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5"
            ></textarea>
            <!-- <input matInput type="text" formControlName="dinner"> -->
            <!-- <mat-error *ngIf="studentForm.controls['firstName'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
        </form>
        <div class="btn-row">
          <button mat-raised-button class="basic-btn" matStepperPrevious>
            <img [src]="backIcon" /> Back
          </button>
          <button
            mat-raised-button
            class="secondary-btn"
            (click)="saveForm('dailyRoutine')"
          >
            Save for later <img [src]="saveIcon" />
          </button>
          <button mat-raised-button class="primary-btn" matStepperNext>
            Next <img [src]="nextIcon" />
          </button>
        </div>
      </mat-step>
      <mat-step [stepControl]="miscelleneous">
        <form [formGroup]="miscelleneous" class="miscelleneous">
          <ng-template matStepLabel>Almost Done!</ng-template>
          <mat-form-field appearance="outline">
            <mat-label
              >What is your health goal? What would you like to
              accomplish?</mat-label
            >
            <textarea
              matInput
              formControlName="healthGowl"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5"
            ></textarea>
            <!-- <mat-error *ngIf="studentForm.controls['email'].invalid">{{getErrorMessage()}}</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label
              >Anything else which you like to mention? Please feel free to
              write your heart out.</mat-label
            >
            <textarea
              matInput
              formControlName="writeAnything"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5"
            ></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>How did you hear about us?</mat-label>
            <mat-select required formControlName="modeOfCommunication" multiple>
              <mat-option *ngFor="let m of modeOfCommunication" [value]="m">{{
                m
              }}</mat-option>
            </mat-select>
            <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="modeOfCommunicationOther">
            <mat-label>Other</mat-label>
            <input
              matInput
              type="number"
              formControlName="modeOfCommunicationOther"
            />
            <!-- <mat-error *ngIf="studentForm.controls['address'].invalid">You must enter a value</mat-error> -->
          </mat-form-field>
        </form>
        <div class="btn-row">
          <button mat-raised-button class="basic-btn" matStepperPrevious>
            <img [src]="backIcon" /> Back
          </button>
          <!-- <button
            mat-raised-button
            class="secondary-btn"
            (click)="saveForm('miscelleneous')"
          >
            Save for later <img [src]="saveIcon" />
          </button> -->
          <button
            mat-raised-button
            class="primary-btn"
            (click)="onSubmit('miscelleneous')"
            matStepperNext
          >
            Submit <img [src]="submitIcon" />
          </button>
        </div>
      </mat-step>
    </mat-stepper>
  </mat-card>
</div>

<div class="container-2" *ngIf="isFormSubmitted">
  <mat-card class="email-verify">
    <h1>Wonderful...</h1>
    <img [src]="happyIcon" />
    <h2>
      "Thank you for submitting the questionnaire. Your consultation will be
      scheduled soon, and you will be notified of the details via email or
      phone."
    </h2>
    <!-- <button mat-raised-button class="primary-btn" (click)="isFormSubmitted = false">
      Email verified? Login again
    </button> -->
  </mat-card>
</div>
